import { combineReducers } from "@reduxjs/toolkit";

import authReducer from "stores/auth/authSlice";
// import modalReducer from "stores/modal/modalSlice";
import uiReducer from "stores/ui/uiSlice";
import deviceDataReducer from "stores/userData/deviceDataSlice";
import websocketReducer from 'stores/webSocket/websocketSlice';

const rootReducer = combineReducers({
  authReducer,
  uiReducer,
  deviceDataReducer,
  websocket: websocketReducer,
  //   modalReducer,
});

export default rootReducer;